
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categoryOrContentPageSlug]",
      function () {
        return require("private-next-pages/[categoryOrContentPageSlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categoryOrContentPageSlug]"])
      });
    }
  